<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-06-30 14:58:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-03 16:16:21
-->
<template>
  <!-- 取消提交按钮组 -->
  <div class="btnGroup"
       :style="{ backgroundColor: backgroundColor }">
    <v-btn class="cencelBtn"
           color="primary"
           @click="cancel"
           depressed
           :small="small"
           :disabled="loading"
           rounded
           v-if="cancelShow"
           text>
      <span class="text-button">
        {{ cancelText || $t('label_cancel') }}
      </span>
    </v-btn>
    <v-btn v-if="!hideSuccess"
           :color="successBackgroundColor"
           @click="!loading && success()"
           :loading="loading"
           rounded
           :small="small"
           depressed
           :disabled="disabled||loading"
           class="successBtn">
      <span class="text-button">
        {{ successText || $t('label_submit') }}
      </span>
    </v-btn>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    hideSuccess: {
      type: Boolean,
      default: false,
    },
    height: {
      default: '48'
    },
    cancelShow: {
      type: Boolean,
      default: true,
    },
    cancelText: {
      type: String,
    },
    successText: {
      type: String,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: '#e0e0e0',
    },
    successBackgroundColor: {
      type: String,
      // default: 'transparent'
      default: 'primary',
    },
  },
  data () {
    return {}
  },
  created () { },
  mounted () { },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    success () {
      this.$emit('success')
    },
  },
  computed: {},
  watch: {},
}
</script>

<style scoped>
.btnGroup {
  display: flex;
  justify-content: center;
  align-items: center;
  /* min-width: 200px;
  max-width: 300px; */
  /* margin: 0 auto; */
  /* margin-top: 20px; */
  /* background: #e0e0e0; */
  border-radius: 0px 0px 8px 8px;
  width: 100%;
  height: 80px;
}
.successBtn {
  color: #fff;
  max-height: 32px !important;
  min-width: 93px !important;
  margin-left: 28px;
}
.cencelBtn {
  max-height: 32px !important;
  min-width: 93px !important;
  margin-right: 28px;
}
</style>
